"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripeChangePaymentMethod = void 0;
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var input_output_helper_const_1 = require("@src/const/input-output-helper.const");
var object_service_1 = require("@src/services/object-service");
var settings_service_1 = require("@src/services/settings.service");
var stripe_js_1 = require("@stripe/stripe-js");
var cash_dom_1 = __importDefault(require("cash-dom"));
var stripe_change_payment_method_helper_1 = require("./stripe-change-payment-method.helper");
var StripeChangePaymentMethod = /** @class */ (function () {
    function StripeChangePaymentMethod() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
    }
    StripeChangePaymentMethod.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var details, container, _a, _b, handledReturningPaymentMethod;
            var _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        (0, generator_const_1._HideErrorMessage)();
                        details = (0, stripe_change_payment_method_helper_1.readStripeChangePaymentMethodDetails)();
                        if (!details) {
                            (0, generator_const_1._ShowErrorMessage)('Ungueltiger Link');
                            return [2 /*return*/];
                        }
                        this.details = details;
                        container = (_e = (_d = (_c = this.module) === null || _c === void 0 ? void 0 : _c.references) === null || _d === void 0 ? void 0 : _d.changePaymentMethodContainer) === null || _e === void 0 ? void 0 : _e.domElement;
                        if (!container || !container.length) {
                            (0, generator_const_1._ShowErrorMessage)('Stripe Container nicht gefunden');
                            console.error("Missing data-ref='stripe-payment-container' for stripe-change-payment-method");
                            return [2 /*return*/];
                        }
                        (0, generator_const_1._CreateLoadingScreen)();
                        _a = this;
                        return [4 /*yield*/, (0, stripe_change_payment_method_helper_1.createStripeChangePaymentMethodSession)(this.config.get, this.details)];
                    case 1:
                        _a.session = _h.sent();
                        if (!((_f = this.session) === null || _f === void 0 ? void 0 : _f.clientSecret) || !((_g = this.session) === null || _g === void 0 ? void 0 : _g.stripeAccount)) {
                            (0, generator_const_1._DeleteLoadingScreen)();
                            (0, generator_const_1._ShowErrorMessage)('Keine Zahlungsdaten gefunden');
                            return [2 /*return*/];
                        }
                        _b = this;
                        return [4 /*yield*/, (0, stripe_js_1.loadStripe)((0, stripe_change_payment_method_helper_1.getStripePublicKey)(this.config.get), {
                                stripeAccount: this.session.stripeAccount,
                            })];
                    case 2:
                        _b.stripe = _h.sent();
                        if (!this.stripe) {
                            (0, generator_const_1._DeleteLoadingScreen)();
                            (0, generator_const_1._ShowErrorMessage)('Stripe konnte nicht geladen werden');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.handleReturningSetupIntent()];
                    case 3:
                        handledReturningPaymentMethod = _h.sent();
                        if (handledReturningPaymentMethod) {
                            (0, generator_const_1._DeleteLoadingScreen)();
                            return [2 /*return*/];
                        }
                        this.mountStripeElements(container);
                        this.bindSubmit();
                        this.writeCustomerData();
                        (0, generator_const_1._DeleteLoadingScreen)();
                        return [2 /*return*/];
                }
            });
        });
    };
    StripeChangePaymentMethod.prototype.mountStripeElements = function (container) {
        var _this = this;
        var _a, _b, _c, _d;
        if (this.paymentElement) {
            this.paymentElement.unmount();
        }
        if (this.expressElement) {
            this.expressElement.unmount();
        }
        container.empty();
        var expressWrapper = document.createElement('div');
        var paymentWrapper = document.createElement('div');
        paymentWrapper.className = 'stripe-change-payment-method-element';
        expressWrapper.className = 'stripe-change-payment-method-express';
        container.append(expressWrapper);
        container.append(paymentWrapper);
        var appearance = __assign(__assign({}, (((_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.stripe) === null || _b === void 0 ? void 0 : _b.appearance) || {})), { theme: ((_d = (_c = this.config.get) === null || _c === void 0 ? void 0 : _c.stripe) === null || _d === void 0 ? void 0 : _d.theme) || 'night' });
        this.stripeElements = this.stripe.elements({
            clientSecret: this.session.clientSecret,
            appearance: appearance,
            locale: 'de',
        });
        var expressCheckoutOptions = {
            buttonType: {
                applePay: 'plain',
                googlePay: 'plain',
            },
            paymentMethods: {
                googlePay: 'always',
                applePay: 'always',
                amazonPay: 'auto',
                link: 'auto',
            },
            paymentMethodOrder: ['apple_pay', 'google_pay', 'amazon_pay', 'link'],
        };
        this.expressElement = this.stripeElements.create('expressCheckout', expressCheckoutOptions);
        this.expressElement.on('click', function (event) {
            (0, generator_const_1._CreateLoadingScreen)();
            var options = {
                emailRequired: true,
                billingAddressRequired: true,
                business: { name: 'fittec GmbH' },
            };
            event.resolve(options);
        });
        this.expressElement.on('confirm', function (event) { return _this.confirmExpressCheckout(event); });
        this.expressElement.on('cancel', function () {
            (0, generator_const_1._DeleteLoadingScreen)();
            (0, generator_const_1._ShowErrorMessage)('Bezahlung abgebrochen');
        });
        this.expressElement.on('loaderror', function (event) { return console.error('Stripe express checkout load error:', event); });
        this.expressElement.mount(expressWrapper);
        this.paymentElement = this.stripeElements.create('payment', {
            layout: {
                type: 'accordion',
                defaultCollapsed: false,
                radios: true,
                spacedAccordionItems: false,
            },
            paymentMethodOrder: ['card', 'klarna', 'apple_pay', 'google_pay', 'amazon_pay'],
        });
        this.paymentElement.on('change', function (event) {
            var _a;
            if ((_a = event === null || event === void 0 ? void 0 : event.value) === null || _a === void 0 ? void 0 : _a.type) {
                localStorage.setItem('selectedPaymentMethod', event.value.type);
            }
        });
        this.paymentElement.mount(paymentWrapper);
    };
    StripeChangePaymentMethod.prototype.bindSubmit = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        var submit = (_c = (_b = (_a = this.module) === null || _a === void 0 ? void 0 : _a.references) === null || _b === void 0 ? void 0 : _b.submit) === null || _c === void 0 ? void 0 : _c.domElement;
        submit === null || submit === void 0 ? void 0 : submit.off('click');
        submit === null || submit === void 0 ? void 0 : submit.on('click', function (event) {
            event.preventDefault();
            _this.submitPaymentMethodChange();
        });
        var webflowSubmit = (_f = (_e = (_d = this.module) === null || _d === void 0 ? void 0 : _d.references) === null || _e === void 0 ? void 0 : _e.webflowSubmit) === null || _f === void 0 ? void 0 : _f.domElement;
        if (webflowSubmit) {
            var form = webflowSubmit.closest('form');
            (0, input_output_helper_const_1._OverwriteIndirectFormSubmit)(form, function () { return _this.submitPaymentMethodChange(); });
        }
    };
    StripeChangePaymentMethod.prototype.submitPaymentMethodChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var submitResult, result, finished;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, generator_const_1._CreateLoadingScreen)();
                        (0, generator_const_1._HideErrorMessage)();
                        return [4 /*yield*/, this.stripeElements.submit()];
                    case 1:
                        submitResult = _a.sent();
                        if (submitResult.error) {
                            (0, generator_const_1._DeleteLoadingScreen)();
                            (0, generator_const_1._ShowErrorMessage)(submitResult.error.message || 'Zahlungsdaten ungueltig');
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this.confirmSetup()];
                    case 2:
                        result = _a.sent();
                        if (!(result.success && result.setupIntent)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.finishSuccessfulPaymentMethodChange(result.setupIntent)];
                    case 3:
                        finished = _a.sent();
                        (0, generator_const_1._DeleteLoadingScreen)();
                        return [2 /*return*/, finished];
                    case 4:
                        (0, generator_const_1._DeleteLoadingScreen)();
                        (0, generator_const_1._ShowErrorMessage)(result.message || 'Bezahlung fehlgeschlagen');
                        return [2 /*return*/, false];
                }
            });
        });
    };
    StripeChangePaymentMethod.prototype.confirmExpressCheckout = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        localStorage.setItem('selectedPaymentMethod', event.expressPaymentType);
                        return [4 /*yield*/, this.confirmSetup()];
                    case 1:
                        result = _a.sent();
                        if (!(result.success && result.setupIntent)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.finishSuccessfulPaymentMethodChange(result.setupIntent)];
                    case 2:
                        _a.sent();
                        (0, generator_const_1._DeleteLoadingScreen)();
                        return [2 /*return*/];
                    case 3:
                        (0, generator_const_1._DeleteLoadingScreen)();
                        (0, generator_const_1._ShowErrorMessage)(result.message || 'Bezahlung fehlgeschlagen');
                        return [2 /*return*/];
                }
            });
        });
    };
    StripeChangePaymentMethod.prototype.confirmSetup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error, setupIntent, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stripe
                            .confirmSetup({
                            elements: this.stripeElements,
                            confirmParams: {
                                return_url: (0, stripe_change_payment_method_helper_1.buildStripeChangePaymentMethodReturnUrl)(this.details),
                            },
                            redirect: 'if_required',
                        })
                            .catch(function (e) {
                            console.error('Error confirming payment method change:', e);
                            return undefined;
                        })];
                    case 1:
                        result = _a.sent();
                        if (!result) {
                            return [2 /*return*/, { success: false, message: 'Bezahlung fehlgeschlagen' }];
                        }
                        error = result.error;
                        setupIntent = result.setupIntent;
                        if (error) {
                            console.error('Stripe payment method change error:', error);
                            return [2 /*return*/, { success: false, message: error.message || 'Bezahlung fehlgeschlagen' }];
                        }
                        if (!setupIntent) {
                            return [2 /*return*/, { success: false, message: 'Bezahlung fehlgeschlagen' }];
                        }
                        return [2 /*return*/, { success: true, setupIntent: setupIntent }];
                }
            });
        });
    };
    StripeChangePaymentMethod.prototype.handleReturningSetupIntent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var setupIntentClientSecret, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setupIntentClientSecret = new URLSearchParams(window.location.search).get('setup_intent_client_secret');
                        if (!setupIntentClientSecret) {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this.stripe.retrieveSetupIntent(setupIntentClientSecret).catch(function (error) {
                                console.error('Error retrieving setup intent:', error);
                                return undefined;
                            })];
                    case 1:
                        result = _a.sent();
                        if (!(result === null || result === void 0 ? void 0 : result.setupIntent)) {
                            (0, generator_const_1._ShowErrorMessage)('Bezahlung fehlgeschlagen');
                            return [2 /*return*/, false];
                        }
                        if (!(result.setupIntent.status === 'succeeded')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.finishSuccessfulPaymentMethodChange(result.setupIntent)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 3:
                        if (result.setupIntent.status === 'requires_payment_method') {
                            (0, generator_const_1._ShowErrorMessage)('Bezahlung fehlgeschlagen. Bitte erneut versuchen oder Bezahlweise wechseln.');
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    StripeChangePaymentMethod.prototype.finishSuccessfulPaymentMethodChange = function (setupIntent) {
        return __awaiter(this, void 0, void 0, function () {
            var changeResult, webflowSubmit, successElement;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            return __generator(this, function (_q) {
                switch (_q.label) {
                    case 0: return [4 /*yield*/, (0, stripe_change_payment_method_helper_1.changeStripePaymentMethod)(this.config.get, {
                            stripeAccount: this.session.stripeAccount,
                            connectedAccountId: this.session.stripeAccount,
                            customerId: this.session.customerId,
                            stripeCustomerId: this.session.customerId,
                            setupIntentId: setupIntent.id,
                            setupIntentClientSecret: setupIntent.client_secret || this.session.clientSecret,
                            paymentMethodName: this.getPaymentMethodName(setupIntent),
                            paymentProvider: this.getPaymentProvider(setupIntent),
                        })];
                    case 1:
                        changeResult = _q.sent();
                        if (!changeResult.success) {
                            (0, generator_const_1._ShowErrorMessage)(changeResult.message || 'Bezahlung fehlgeschlagen');
                            return [2 /*return*/, false];
                        }
                        webflowSubmit = (_c = (_b = (_a = this.module) === null || _a === void 0 ? void 0 : _a.references) === null || _b === void 0 ? void 0 : _b.webflowSubmit) === null || _c === void 0 ? void 0 : _c.domElement;
                        if (webflowSubmit === null || webflowSubmit === void 0 ? void 0 : webflowSubmit.length) {
                            webflowSubmit.trigger('click');
                            return [2 /*return*/, true];
                        }
                        (0, generator_const_1._HideErrorMessage)();
                        (_g = (_f = (_e = (_d = this.module) === null || _d === void 0 ? void 0 : _d.references) === null || _e === void 0 ? void 0 : _e.changePaymentMethodContainer) === null || _f === void 0 ? void 0 : _f.domElement) === null || _g === void 0 ? void 0 : _g.hide();
                        (_l = (_k = (_j = (_h = this.module) === null || _h === void 0 ? void 0 : _h.references) === null || _j === void 0 ? void 0 : _j.submit) === null || _k === void 0 ? void 0 : _k.domElement) === null || _l === void 0 ? void 0 : _l.hide();
                        successElement = ((_p = (_o = (_m = this.module) === null || _m === void 0 ? void 0 : _m.references) === null || _o === void 0 ? void 0 : _o.success) === null || _p === void 0 ? void 0 : _p.domElement) || this.$container.find("[data-ref='stripe-payment-successful']");
                        successElement === null || successElement === void 0 ? void 0 : successElement.show();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    StripeChangePaymentMethod.prototype.getPaymentMethodName = function (setupIntent) {
        var _a;
        var selectedPaymentMethod = localStorage.getItem('selectedPaymentMethod');
        if (selectedPaymentMethod) {
            return this.isExpressCheckoutProvider(selectedPaymentMethod) ? 'card' : selectedPaymentMethod;
        }
        var setupIntentPaymentMethodType = (_a = setupIntent.payment_method_types) === null || _a === void 0 ? void 0 : _a[0];
        if (setupIntentPaymentMethodType) {
            return setupIntentPaymentMethodType;
        }
        return 'card';
    };
    StripeChangePaymentMethod.prototype.getPaymentProvider = function (setupIntent) {
        var selectedPaymentMethod = localStorage.getItem('selectedPaymentMethod');
        if (selectedPaymentMethod) {
            return selectedPaymentMethod;
        }
        return this.getPaymentMethodName(setupIntent);
    };
    StripeChangePaymentMethod.prototype.isExpressCheckoutProvider = function (paymentMethod) {
        return ['apple_pay', 'google_pay', 'amazon_pay', 'link'].includes(paymentMethod);
    };
    StripeChangePaymentMethod.prototype.writeCustomerData = function () {
        var _a, _b;
        var firstname = (_a = this.session.customer) === null || _a === void 0 ? void 0 : _a.firstName;
        var lastname = (_b = this.session.customer) === null || _b === void 0 ? void 0 : _b.lastName;
        var currentPaymentMethod = this.session.currentPaymentMethod;
        if (firstname) {
            (0, cash_dom_1.default)("[data-get='customer.firstname']").html(firstname);
        }
        if (lastname) {
            (0, cash_dom_1.default)("[data-get='customer.lastname']").html(lastname);
        }
        if (currentPaymentMethod) {
            (0, cash_dom_1.default)("[data-get='customer.currentPaymentMethod']").html(currentPaymentMethod);
        }
    };
    return StripeChangePaymentMethod;
}());
exports.StripeChangePaymentMethod = StripeChangePaymentMethod;
